import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">RoadAssist Pro © 2025 - All rights reserved</div>`
})
export class AppFooter {}
